import { render, staticRenderFns } from "./PartnerApplicationApprove.vue?vue&type=template&id=0ec7ffe3&scoped=true"
import script from "./PartnerApplicationApprove.vue?vue&type=script&lang=js"
export * from "./PartnerApplicationApprove.vue?vue&type=script&lang=js"
import style0 from "./PartnerApplicationApprove.vue?vue&type=style&index=0&id=0ec7ffe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7ffe3",
  null
  
)

export default component.exports